// extracted by mini-css-extract-plugin
module.exports = {"row":"Logger_row__2XR7q","root":"Logger_root__2uilZ","element":"Logger_element__3NFfK","label":"Logger_label__145YN","text":"Logger_text__219jE"};